import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
    { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule) },
    { path: 'product', loadChildren: () => import('./pages/product/product.module').then(m => m.ProductPageModule) },
    {
        path: 'my-account',
        loadChildren: () => import('./pages/my-account/my-account.module').then(m => m.MyAccountPageModule),
        data: {
            breadcrumb: 'MY-ACCOUNT',
        },
    },
    { path: 'cart', loadChildren: () => import('./pages/cart/cart.module').then(m => m.CartPageModule) },
    { path: 'legal-notice', loadChildren: () => import('./pages/legal-notice/legal-notice.module').then(m => m.LegalNoticeModule) },

    { path: 'error', loadChildren: () => import('./pages/error/error.module').then(m => m.ErrorPageModule) },
    { path: 'news', loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule) },
    { path: '**', redirectTo: '/error/404' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        enableTracing: false,
        useHash: false
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
